import { safeGet } from "../utils/request-helpers";
import { route } from "ziggy-js";
export const getUsersByBrand = (brandID, filters = {}) => {
    return safeGet(route('api.v1.user.brand.users', { brandID }), filters);
};
export const getGraphicArtistOptions = () => {
    return safeGet(route('api.v1.user.graphic.artist.options'));
};
export const getUserProfile = () => {
    return safeGet(route('api.v1.user.profile'));
};
